export default function GS_Delete_Cells() {
  return (
    <div className="p-4">
      <h1>GS Delete Cells</h1>
    </div>
  );
}
